<ng-container [ngSwitch]="orderFulfillmentStatus()">
  <ng-container *ngSwitchCase="OrderItemStatus.Fulfilled">
    <rd-shared-icon
      class="mx-auto mt-0 mb-8"
      [iconSymbol]="'icon-success'"
      [iconTheme]="'success'"></rd-shared-icon>
    <h1 class="redeem-cash-status-text confirmed mt-0 mb-6" aria-live="polite">
      {{ 'redeem_cash_v2.success.status_text_confirmed' | translate }}
    </h1>
    <p
      class="redeem-cash-order-id mt-0 mb-6"
      [innerHTML]="
        'redeem_cash_v2.success.order_id' | translate: orderIdParams()
      "></p>
    <p
      *ngIf="shouldShowTransactionStatusMessage()"
      class="redeem-cash-disclaimer mt-0 mb-6"
      [innerHTML]="
        successPageText.confirmedStatusMessage.translationKey | translate
      "></p>
  </ng-container>

  <ng-container *ngSwitchCase="OrderItemStatus.Pending">
    <rd-shared-icon
      class="mx-auto mt-0 mb-8"
      [iconSymbol]="'icon-progress'"
      [iconTheme]="'warn'"></rd-shared-icon>
    <h1 class="redeem-cash-status-text pending mt-0 mb-6" aria-live="polite">
      {{ 'redeem_cash_v2.success.status_text_pending' | translate }}
    </h1>
    <p
      class="redeem-cash-order-id mt-0 mb-6"
      [innerHTML]="
        'redeem_cash_v2.success.order_id' | translate: orderIdParams()
      "></p>
    <p
      *ngIf="shouldShowTransactionStatusMessage()"
      class="redeem-cash-disclaimer mt-0 mb-6"
      [innerHTML]="
        'redeem_cash_v2.success.notification_disclaimer' | translate
      "></p>
  </ng-container>

  <ng-container *ngSwitchCase="OrderItemStatus.Failed">
    <rd-shared-icon
      class="mx-auto mt-0 mb-8"
      [iconSymbol]="'icon-error'"
      [iconTheme]="'error'"></rd-shared-icon>
    <h1 class="redeem-cash-status-text failed mt-0 mb-6" aria-live="polite">
      {{ 'redeem_cash_v2.success.status_text_failed' | translate }}
    </h1>
    <p
      class="redeem-cash-order-id mt-0 mb-6"
      [innerHTML]="
        'redeem_cash_v2.success.order_id' | translate: orderIdParams()
      "></p>
    <p
      *ngIf="shouldShowTransactionStatusMessage()"
      class="redeem-cash-disclaimer mt-0 mb-6"
      [innerHTML]="
        successPageText.failedStatusMessage.translationKey | translate
      "></p>
  </ng-container>
</ng-container>
